import React, { useEffect, useMemo, useRef, useState } from 'react';
import './css/DocumentsTemplate.css';
import { toAbsoluteUrl } from '../../../../../_metronic/helpers';
import { KTSVGWhite } from '_metronic/helpers/components/KTSVGWhite';
import axios from 'axios';
import { toast } from 'react-toastify';
import UploadButton from 'app/components/UploadButton';
import { DocumentsMap } from 'app/types/documents';
const API_URL = process.env.REACT_APP_API_NET;

type Props = {
    handleUpload: (files?: FileList | null) => any;
    handleDelete: (id: number | string) => void;
    document: DocumentsMap
};

const DocumentSubSection: React.FC<Props> = ({
    handleUpload,
    document,
    handleDelete,
}) => {
    const [extension, fileName] = useMemo(() => {
        if (document.file) {
            const spl = document.file.name.split('.');
            return [spl.pop(), spl.join('.')];
        }
        return ['generic', 'Nombre del archivo'];
    }, [document]);


    const downloadFile = async (id: number) => {
        axios.get(`${API_URL}Document/${id}`, {
            responseType: 'blob',
            withCredentials: true,
        }).then((res) => {
            let fileName : string = '';
            const name = res.headers['filename'];

            const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
            const link = window.document.createElement('a');

            link.href = url;
            link.download = name;

            link.click();
        });
    }

    return (
        <div className="d-flex flex-column mb-0">
            <div
                className="d-flex mb-5 align-items-center"
                style={{
                    borderBottom: 'lightgrey 1px dashed',
                    paddingBottom: '1rem',
                }}
            >
                <h2 style={{ width: '40%', color: 'lightgray' }}>{document.description}</h2>
                <div
                    className="d-flex align-items-center"
                    style={{
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                        width: '60%',
                    }}
                >
                    <div className="symbol symbol-30px me-5">
                        <img
                            src={toAbsoluteUrl(
                                `/media/svg/files/${extension}.svg`
                            )}
                            alt="Icono"
                        />
                    </div>
                    <div className="fw-semibold">
                        <a
                            className="fs-8 fw-bold text-gray-900 text-hover-primary large-text"
                            onClick={() => downloadFile(document.file?.id!)}
                            rel="noopener noreferrer"
                        >
                            {fileName}
                        </a>
                        <div className="text-gray-500 fs-9 ">
                            {document.file?.createdAt || 'Fecha de creación'}
                            {/* <a className="fs-7 ms-1">
                                {document.file?.status || 'status'}
                            </a> */}
                        </div>
                    </div>
                </div>
                <div style={{ marginLeft: '1.5rem', display: 'flex' }}>
                    {!document.file ? (
                        <UploadButton
                            onChange={handleUpload}
                        />
                    ) : (
                        <button
                            style={{ background: 'none', border: 'none' }}
                            onClick={() => handleDelete(document.file?.id!)}
                        >
                            <a
                                className="badge badge-light-danger  text-hover-danger fw-bold px-4 py-3 cursor-pointer"
                                title="Borrar archivo"
                            >
                                <KTSVGWhite path="/media/icons/duotune/files/fil007.svg" />
                            </a>
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
};

export default DocumentSubSection;
